import { Button, cn } from '@design-system';

import { CalendarClock } from 'lucide-react';

import { FREEMIUM_ONBOARDING_CALL_URL } from '@shared';

interface BookACallButtonProps {
  className?: string;
  label?: string;
}

export function BookACallButton({
  className,
  label = 'Book an onboarding call',
}: BookACallButtonProps) {
  return (
    <Button
      asChild
      size="lg"
      variant="outline"
      className={cn('w-full', className)}
    >
      <a
        href={FREEMIUM_ONBOARDING_CALL_URL}
        target="_blank"
        rel="noreferrer"
      >
        <CalendarClock />
        {label}
      </a>
    </Button>
  );
}
